import React from 'react';

import { Icon } from '../icons';

export const IAIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} style={style} viewBox="0 0 32 32" fill={color}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.86474 7.81082L6.41245 10.716L4.96015 7.81082L2.05447 6.35798L4.96015 4.90568L6.41245 2L7.86474 4.90514L10.7704 6.35798L7.86474 7.81082ZM16.8716 4.61479L15.1284 5.48638L14.2568 7.22957L13.3852 5.48638L11.642 4.61479L13.3852 3.74319L14.2568 2L15.1284 3.74319L16.8716 4.61479ZM27.0398 20.5939L25.5875 17.6887L24.1353 20.5939L21.2296 22.0467L24.1353 23.4995L25.5875 26.4047L27.0398 23.4995L29.9455 22.0467L27.0398 20.5939ZM24.716 11.5875C24.716 12.0691 24.3259 12.4591 23.8444 12.4591H22.5555L7.34723 29.3174C6.67828 30.0567 5.52669 30.0855 4.82179 29.3806L2.5649 27.1237C1.86 26.4188 1.88887 25.2672 2.62809 24.5983L9.02723 18.8256V16.8171C9.02723 16.3356 9.41727 15.9455 9.89883 15.9455H12.2195L27.4282 2.22553C27.7725 1.91393 28.3009 1.927 28.6294 2.25549L29.6906 3.31611C30.0191 3.64459 30.0321 4.173 29.7205 4.51728L24.716 10.0644V11.5875Z"
        fill={color}
      />
    </svg>
  );
};
